export default {"src":"/_next/static/media/7.17287648.svg","height":544,"width":595,"blurWidth":0,"blurHeight":0};